export default __webpack_public_path__ + "static/media/mako-black.dede4ea1.svg";